// @flow

import React from 'react';
import PropTypes from 'prop-types';
import {
    Typography,
    Grid,
    List,
    ListItem,
    ListItemAvatar,
    Link
} from '@material-ui/core';
import Image from '../../../../components/image';
import Assets from '../../../../assets';
import { AppConfig } from '../../../../config';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import { type ListCMS } from '../../../../data/cms//types/download-scripts';
import './style.css';
import NoSearchResult from '../../../search/noresult-search';
type Props = {
    Content: ListCMS
};
function Lists(props: Props) {
    const { Content, searchValue } = props;
    React.useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
       let searchData = Content.List
        .filter(Content => Content.Title.toLowerCase().includes(searchValue.toLowerCase()));
        return (
        <Grid container className="script-section">
            <Grid container spacing={1}>
                {searchData.length ? searchData.map((row, index) => (
                    <Grid key={index} item xs={12} sm={12} md={4} lg={4}>
                        <Typography component="div" className="script-content">
                            <List>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Image
                                            src={Assets.Icons.Bolt.Path}
                                            alt={Assets.Icons.Bolt.Alt}
                                            className="script-img"
                                        />
                                    </ListItemAvatar>
                                    <Typography component="h4">
                                        {row.Title}
                                    </Typography>
                                </ListItem>
                            </List>
                            <Typography component="span">
                                {row.Line1}
                            </Typography>
                            <Typography
                                component="div"
                                className="script-ac-btn"
                            >
                                <ArrowRightAltIcon />
                                <Link
                                    href={`${AppConfig.Scripts}${row.URL}`}
                                    download
                                >
                                    {row.link}
                                </Link>
                            </Typography>
                        </Typography>
                    </Grid>
                )) : <NoSearchResult />}
            </Grid>
        </Grid>
    );
}
Lists.propTypes = {
    Content: PropTypes.object.isRequired
};
export default Lists;
